import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-close-icon',
  standalone: true,
  templateUrl: './close-icon.component.html',
  styleUrls: ['./close-icon.component.scss']
})
export class CloseIconComponent {
  @Input() width: number | string = 14;
  @Input() height: number | string = 14;
}
